import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=5461775d&scoped=true&"
import script from "./SearchBox.vue?vue&type=script&lang=js&"
export * from "./SearchBox.vue?vue&type=script&lang=js&"
import style0 from "./SearchBox.vue?vue&type=style&index=0&id=5461775d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5461775d",
  null
  
)

export default component.exports